import { create } from 'zustand';

type TLayoutStore = {
  isMobile: boolean;
  setIsMobile: (isMobile: boolean) => void;
};

/**
 * Used to track global UI state
 */
const useLayoutStore = create<TLayoutStore>(set => ({
  isMobile: false,
  setIsMobile: isMobile => set(() => ({ isMobile })),
}));

export default useLayoutStore;
